import { render, staticRenderFns } from "./SAMLRedirectView.vue?vue&type=template&id=c8871ab8&scoped=true"
import script from "./SAMLRedirectView.vue?vue&type=script&lang=js"
export * from "./SAMLRedirectView.vue?vue&type=script&lang=js"
import style0 from "./SAMLRedirectView.vue?vue&type=style&index=0&id=c8871ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8871ab8",
  null
  
)

export default component.exports